import {TrainingData} from "../types/TrainingData";
import {StagingTitelineAppTraining} from "../types/StagingTitelineAppTraining";
import { getApiUrl } from '../config/api';

export const fetchTrainingByPid = async (pid?: number, aid: number = -1): Promise<TrainingData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineTraining/GetTrainingByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No training found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching training for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppTraining[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((training) => training.DataSource === aid.toString());
        }

        return backendData.map((training) => ({
            key: training.TrId,
            tr_id: training.TrId,
            pid: training.Pid,
            details: training.Details,
            instructor: training.Instructor,
            trainee: training.Trainee,
            time: training.Time,
        }));

    } catch (error) {
        console.error("Error in fetchTrainingByPid API call:", error);
        return [];
    }
};

export const addTrainingRow = async (trainingRow: TrainingData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineTraining/AddTraining');

    const cloudPayload = [
        {
            Pid: trainingRow.pid,
            Details: trainingRow.details,
            Instructor: trainingRow.instructor,
            Trainee: trainingRow.trainee,
            Time: trainingRow.time,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Training row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add training row to cloud:",
                response.status, response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addTrainingRow API call:", error);
        return false;
    }
};

export const updateTrainingRow = async (tr_id: number, updatedRow: TrainingData) => {
    const apiUrl = getApiUrl(`/api/TitelineTraining/UpdateTrainingByTrId/${tr_id}`);

    const cloudPayload = {
        Details: updatedRow.details,
        Instructor: updatedRow.instructor,
        Trainee: updatedRow.trainee,
        Time: updatedRow.time,
    };

    console.log("cloudPayload:", cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Training row with TrId ${tr_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update training row with TrId ${tr_id}:`,
                response.status, response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateTrainingRow API call:", error);
        return false;
    }
};

export const deleteTrainingByTrId = async (tr_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineTraining/DeleteTrainingByTrId/${tr_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteTrainingByTrId API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete training row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteTrainingByTrId API call:", error);
        return false;
    }
};